export const BASE_URL = import.meta.env.VITE_API_URL || "https://api.inflectco.com";
export const API_URL = BASE_URL; // Alias for backward compatibility
